import GenericCard from "@ui-components/Card/GenericCard";
import { formatDataRateSmart } from "kontrolEdge/helpers/formatDataRate";
import React from "react";

type ChartCardProps = {
  title: string;
  subtitle: string;
  chart: React.ReactNode;
  legendData: { name: string; value: number; color: string }[];
  extraLegendData?: {
    name: string;
    value: string;
    total?: string;
    color: string;
  }[];
  unit?: string;
  isLoading?: boolean;
  hideValue?: boolean;
};

export const ChartCard = ({
  title,
  subtitle,
  chart,
  isLoading = false,
  legendData,
  hideValue,
  extraLegendData,
}: ChartCardProps) => {
  //Determine if there’s data, if not, show a message
  const hasData = legendData.some((entry) => entry.value > 0);

  if (!isLoading && !hasData) {
    return (
      <GenericCard
        isCollapsible={false}
        bodyContent={
          <div className="flex items-center justify-center w-full py-10">
            <p className="text-sm text-semantic-text-secondary">
              Data not available at the moment
            </p>
          </div>
        }
      />
    );
  }

  return (
    <GenericCard
      isCollapsible={false}
      isLoading={isLoading}
      bodyContent={
        <div className="flex items-center justify-evenly w-full py-1">
          <div className="w-[250px] h-[250px]">{chart}</div>
          <div className="ml-3">
            <h3 className="text-sm font-medium text-semantic-text-primary mb-2">
              {title}
            </h3>
            <p className="text-sm font-medium text-semantic-text-secondary">
              {subtitle}
            </p>
            <div className="flex flex-col gap-1">
              {(extraLegendData ?? legendData).map((entry, index) => {
                  const isFormatted = !!extraLegendData;
                return (
                  <div
                    key={index}
                    className="flex items-center text-sm text-semantic-text-secondary"
                  >
                    <span
                      className="inline-block w-4 h-4 mr-2 rounded-sm"
                      style={{ backgroundColor: entry.color }}
                    />
                    <span className="text-xs">
                      {hideValue
                        ? entry.name
                        : isFormatted
                        ? `${entry.name}: ${(entry as typeof extraLegendData[number]).value}`
                        : `${entry.name}: ${formatDataRateSmart((entry as typeof legendData[number]).value)}`}
                    </span>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      }
    />
  );
};
